import { apiRequest } from './httpRequest';

export type BondCategory = 'PRIMARY' | 'NON_CLASSICAL' | 'INTERMOLECULAR' | 'SPECIALIZED';

/** #1126: how a kind of bond is drawn in PeruseLab's editor. */
export type BondDrawingHow = 'TOOL' | 'ORDINARY_BONDS' | 'NOT_YET' | 'NOT_A_BOND';

export interface BondType {
  readonly slug: string;
  readonly name: string;
  readonly category: BondCategory;
  readonly definition: string;
  readonly examples: readonly string[];
  /** #1126 (owner, 2026-10-29): how to draw it in PeruseLab, for the public glossary. */
  readonly drawing: { readonly how: BondDrawingHow; readonly note: string } | null;
}

export async function listBondTypes(): Promise<readonly BondType[]> {
  return apiRequest<BondType[]>('/bond-types', 'bond taxonomy');
}
